<template>
  <the-new-header></the-new-header>

  <div class="for-student-section">
    <RouterView></RouterView>
  </div>

  <the-footer></the-footer>
</template>

<style scoped>
  .for-student-section {
    padding: 0 170px;
    min-height: 525px;
  }

  @media (max-width: 1356px) {
    .for-student-section {
      padding: 0 100px;
    }
  }

  @media (max-width: 1080px) {
    .for-student-section {
      padding: 0 50px;
    }
  }

  @media (max-width: 720px) {
    .for-student-section {
      padding: 0px 20px;
    }
  }
</style>
